import { useMemo } from 'react';
import { resolvePosCommercantTimeZoneFromSources } from '../utils/posCaisseClock.js';

function readAdminUserCommercant() {
  try {
    const user = JSON.parse(localStorage.getItem('admin_user') || '{}');
    return user.commercant || null;
  } catch {
    return null;
  }
}

/**
 * Fuseau d'affichage POS — contexte Admin existant uniquement (pas de nouvel appel API).
 * Sans timezone commerçant en base : source `fallback` + Europe/Paris.
 */
export function usePosDisplayTimeZone(options = {}) {
  const { commercantTimeZone: explicitTz, commercant: commercantProp } = options;

  return useMemo(() => {
    const commercant = commercantProp ?? readAdminUserCommercant();
    return {
      commercant,
      ...resolvePosCommercantTimeZoneFromSources({
        commercantTimeZone: explicitTz,
        commercant,
      }),
    };
  }, [explicitTz, commercantProp]);
}
